import { defineNuxtPlugin } from '#app/nuxt'
import { LazyFooterContacts, LazyFooterCopyright, LazyFooter, LazyFooterMain, LazyFooterNavigation, LazyHeaderAnnouncement, LazyHeader, LazyHeaderNavigation, LazyPagesDesignerPreloader, LazyWidgetsProductsAccessories, LazyWidgetsProductsFeatures, LazyWidgetsProductsHero, LazyWidgetsProductsOverview, LazyWidgetsProductsParallax, LazyWidgetsProductsRelatedProducts, LazyWidgetsProductsServices, LazyFormsFeedback, LazyFormsGeneratorAddressSelect, LazyFormsGeneratorDateTimePicker, LazyFormsGeneratorDefaultChip, LazyFormsGeneratorDefaultEditor, LazyFormsGeneratorDefaultSelect, LazyFormsGenerator, LazyFormsGeneratorProjects, LazyFormsGeneratorQuantity, LazyFormsGeneratorRadio, LazyFormsGeneratorSubFields, LazyFormsGeneratorSubFieldsVideo, LazyFormsGeneratorTelephone, LazyFormsGeneratorUploader, LazyFormsGroupAddress, LazyFormsGroupConversationsFeedback, LazyFormsGroupConversationsProductQuote, LazyFormsGroupEntryForgot, LazyFormsGroupEntry, LazyFormsGroupEntryLogin, LazyFormsGroupEntryRegister, LazyFormsGroupHelpers, LazyFormsGroupPayment, LazyFormsGroupRecipient, LazyFormsGroupSearch, LazyFormsGroupUploadArtwork, LazyFormsUploadFile, LazyFormsUploader, LazyHelpersAddressHtmlFormat, LazyHelpersAuthBlock, LazyHelpersConversationForm, LazyHelpersConversationFormWithJquery, LazyHelpersConversation, LazyHelpersConversationIndexWithJquery, LazyHelpersConversationTypeform, LazyHelpersInfoHeaderBanner, LazyHelpersLoadingError, LazyHelpersOurClientsIcons, LazyHelpersPagination, LazyHelpersProgressConsole, LazyHelpersReviewsCustomers, LazyHelpersReviews, LazyHelpersReviewsItem, LazyHelpersSocials, LazyHelpersSpecificationsCollapsible, LazyHelpersTeam, LazyHelpersThankYouMessage, LazyHelpersTimeStripe, LazyHelpersTooltipHelpers, LazyPagesCardPayment, LazyPagesCatalog, LazyPagesCheckoutBilling, LazyPagesCheckout, LazyPagesCheckoutListItemAddons, LazyPagesCheckoutListItem, LazyPagesCheckoutListItemMainProduct, LazyPagesCheckoutListItemMessages, LazyPagesCheckoutListItemShippings, LazyPagesCheckoutListItemShippingsItem, LazyPagesCheckoutMain, LazyPagesCustomerAddresses, LazyPagesCustomerCampaignsDetails, LazyPagesCustomerCampaignsDetailsMain, LazyPagesCustomerCampaignsDetailsRecipients, LazyPagesCustomerCampaignsDetailsRecipientsList, LazyPagesCustomerCampaigns, LazyPagesCustomerCampaignsList, LazyPagesCustomerCampaignsMain, LazyPagesCustomerCompanyDashboard, LazyPagesCustomerCompanyDashboardList, LazyPagesCustomerCompanyDashboardMain, LazyPagesCustomerCompanyUserManagementCard, LazyPagesCustomerCompanyUserManagement, LazyPagesCustomerCompanyUserManagementUser, LazyPagesCustomerDashboard, LazyPagesCustomerEntryForm, LazyPagesCustomerGallery, LazyPagesCustomerHeadline, LazyPagesCustomer, LazyPagesCustomerInformation, LazyPagesCustomerIntegrationsAndApi, LazyPagesCustomerIntegrationsAndApiZapier, LazyPagesCustomerNotifications, LazyPagesCustomerOrdersDetails, LazyPagesCustomerOrdersExternal, LazyPagesCustomerOrdersExternalMain, LazyPagesCustomerOrders, LazyPagesCustomerOrdersMain, LazyPagesCustomerOrdersShortDetails, LazyPagesCustomerPassword, LazyPagesCustomerPaymentsCard, LazyPagesCustomerPayments, LazyPagesCustomerPaymentsTransactions, LazyPagesCustomerProjectsApprovalsDetails, LazyPagesCustomerProjectsApprovals, LazyPagesCustomerProjectsApprovalsList, LazyPagesCustomerProjectsApprovalsMain, LazyPagesCustomerProjects, LazyPagesCustomerProjectsProjectCard, LazyPagesCustomerProjectsSalesRepForm, LazyPagesCustomerRedeemDetails, LazyPagesCustomerRedeemDetailsMain, LazyPagesCustomerRedeemDetailsRecipients, LazyPagesCustomerRedeemDetailsRecipientsList, LazyPagesCustomerRedeem, LazyPagesCustomerRedeemList, LazyPagesCustomerRedeemMain, LazyPagesCustomerReferrals, LazyPagesCustomerSidebar, LazyPagesCustomerSidebarShowBtn, LazyPagesCustomerThankYouNotesCard, LazyPagesCustomerThankYouNotes, LazyPagesDesignerAddons, LazyPagesDesignerCustomizerActions, LazyPagesDesignerCustomizerEditor, LazyPagesDesignerCustomizerHelp, LazyPagesDesignerCustomizer, LazyPagesDesignerCustomizerOptionsAttrs, LazyPagesDesignerCustomizerOptions, LazyPagesDesignerCustomizerOptionsText, LazyPagesDesignerCustomizerOptionsUploader, LazyPagesDesignerCustomizerPromts, LazyPagesDesignerCustomizerSideSwitch, LazyPagesDesignerCustomizerType, LazyPagesDesignerDiscountModal, LazyPagesDesignerHeader, LazyPagesDesigner, LazyPagesDesignerQuoteSidebar, LazyPagesDesignerReceipt, LazyPagesDesignerReceiptProducts, LazyPagesDesignerSpecifications, LazyPagesDesignerYourinfo, LazyPagesFaq, LazyPagesNotFound, LazyPagesOrderSuccess, LazyPagesPage, LazyPagesPreviewMode, LazyPagesProductActionsForm, LazyPagesProduct, LazyPagesSearch, LazyPagesSharedClaimGiftCheckEmail, LazyPagesSharedClaimGiftEmailPreview, LazyPagesSharedClaimGift, LazyPagesSharedClaimGiftInfoClaimed, LazyPagesSharedClaimGiftInfoForm, LazyPagesSharedClaimGiftInfoGiftCard, LazyPagesSharedClaimGiftInfoGifts, LazyPagesSharedClaimGiftInfo, LazyPagesSharedClaimGiftInfoMain, LazyPagesSharedClaimGiftInfoMessage, LazyPagesSharedClaimGiftInfoThankYou, LazyPagesShared, LazyPagesSharedProject, LazyPagesSharedThankYou, LazyPagesSharedUploader, LazyPagesSharedVideoLibrary, LazyPagesSharedVideoMessage, LazyPagesSitemap, LazyPagesThankYou, LazyPagesUnsubscribe, LazyPopupsCookiesAgree, LazyPopupsCustomDrawer, LazyPopupsPrivacyPolicy, LazyPopupsSubscribe, LazyPopupsToastExpired, LazyPopupsUnsupportedBrowser, LazyPopupsVideoPreviewOverlay, LazyServiceCodes, LazyVercelCodes, LazyWidgetsBannersSimpleVideo, LazyWidgetsHeadlineSimple, LazyWidgets, LazyWidgetsPagesAboutUs, LazyWidgetsPagesAdvantages, LazyWidgetsPagesAdvantagesProduct, LazyWidgetsPagesAnnouncementBanner, LazyWidgetsPagesAnnouncementBannerSecond, LazyWidgetsPagesBannerAndContentWithReverse, LazyWidgetsPagesBannerDescrWithItems, LazyWidgetsPagesBannerDescrWithTabsItems, LazyWidgetsPagesBannerTitleDescrButton, LazyWidgetsPagesCardBlocks, LazyWidgetsPagesContentBlocksWithButton, LazyWidgetsPagesDivided, LazyWidgetsPagesFeedback, LazyWidgetsPagesGallery, LazyWidgetsPagesGalleryBlocks, LazyWidgetsPagesGalleryBlocksModalInfo, LazyWidgetsPagesHtmlContent, LazyWidgetsPagesHtmlContentItems, LazyWidgetsPagesItemsBannerTitleBlock, LazyWidgetsPagesItemsTitleDescr, LazyWidgetsPagesItemsTitleDescrIcon, LazyWidgetsPagesItemsTitleDescrIconBlocks, LazyWidgetsPagesLocalStorage, LazyWidgetsPagesNavigationContent, LazyWidgetsPagesOurClients, LazyWidgetsPagesOurDifference, LazyWidgetsPagesBannerDescrWithCollapsibleItems, LazyWidgetsPagesProducts, LazyWidgetsPagesQuestions, LazyWidgetsPagesRetailersIcons, LazyWidgetsPagesReviewsAndClients, LazyWidgetsPagesReviewsExternal, LazyWidgetsPagesSliderAndContentWithReverse, LazyWidgetsPagesSliderBlocks, LazyWidgetsPagesSliderReviews, LazyWidgetsPagesSliderSteps, LazyWidgetsPagesStepper, LazyWidgetsSystemBreadcrumbs, LazyWidgetsSystemProductsCard, LazyWidgetsSystemProductsCardPlaceholder, LazyWidgetsSystemProductsFilters, LazyWidgetsSystemProducts, LazyWidgetsSystemProductsLoadMore, LazyAutoComplete, LazyCalendar, LazyCascadeSelect, LazyCheckbox, LazyCheckboxGroup, LazyChips, LazyColorPicker, LazyDatePicker, LazyDropdown, LazyEditor, LazyFloatLabel, LazyFluid, LazyIconField, LazyIftaLabel, LazyInputChips, LazyInputGroup, LazyInputGroupAddon, LazyInputIcon, LazyInputMask, LazyInputNumber, LazyInputOtp, LazyInputSwitch, LazyInputText, LazyKnob, LazyListbox, LazyMultiSelect, LazyPassword, LazyRadioButton, LazyRadioButtonGroup, LazyRating, LazySelect, LazySelectButton, LazySlider, LazyTextarea, LazyToggleButton, LazyToggleSwitch, LazyTreeSelect, LazyButton, LazyButtonGroup, LazySpeedDial, LazySplitButton, LazyColumn, LazyRow, LazyColumnGroup, LazyDataTable, LazyDataView, LazyOrderList, LazyOrganizationChart, LazyPaginator, LazyPickList, LazyTree, LazyTreeTable, LazyTimeline, LazyVirtualScroller, LazyAccordion, LazyAccordionPanel, LazyAccordionHeader, LazyAccordionContent, LazyAccordionTab, LazyCard, LazyDeferredContent, LazyDivider, LazyFieldset, LazyPanel, LazyScrollPanel, LazySplitter, LazySplitterPanel, LazyStepper, LazyStepList, LazyStep, LazyStepItem, LazyStepPanels, LazyStepPanel, LazyTabView, LazyTabs, LazyTabList, LazyTab, LazyTabPanels, LazyTabPanel, LazyToolbar, LazyConfirmDialog, LazyConfirmPopup, LazyDialog, LazyDrawer, LazyDynamicDialog, LazyOverlayPanel, LazyPopover, LazySidebar, LazyFileUpload, LazyBreadcrumb, LazyContextMenu, LazyDock, LazyMenu, LazyMenubar, LazyMegaMenu, LazyPanelMenu, LazySteps, LazyTabMenu, LazyTieredMenu, LazyChart, LazyMessage, LazyInlineMessage, LazyToast, LazyCarousel, LazyGalleria, LazyImage, LazyImageCompare, LazyAvatar, LazyAvatarGroup, LazyBadge, LazyBlockUI, LazyChip, LazyInplace, LazyMeterGroup, LazyOverlayBadge, LazyScrollTop, LazySkeleton, LazyProgressBar, LazyProgressSpinner, LazyTag, LazyTerminal } from '#components'
const lazyGlobalComponents = [
  ["FooterContacts", LazyFooterContacts],
["FooterCopyright", LazyFooterCopyright],
["Footer", LazyFooter],
["FooterMain", LazyFooterMain],
["FooterNavigation", LazyFooterNavigation],
["HeaderAnnouncement", LazyHeaderAnnouncement],
["Header", LazyHeader],
["HeaderNavigation", LazyHeaderNavigation],
["PagesDesignerPreloader", LazyPagesDesignerPreloader],
["WidgetsProductsAccessories", LazyWidgetsProductsAccessories],
["WidgetsProductsFeatures", LazyWidgetsProductsFeatures],
["WidgetsProductsHero", LazyWidgetsProductsHero],
["WidgetsProductsOverview", LazyWidgetsProductsOverview],
["WidgetsProductsParallax", LazyWidgetsProductsParallax],
["WidgetsProductsRelatedProducts", LazyWidgetsProductsRelatedProducts],
["WidgetsProductsServices", LazyWidgetsProductsServices],
["FormsFeedback", LazyFormsFeedback],
["FormsGeneratorAddressSelect", LazyFormsGeneratorAddressSelect],
["FormsGeneratorDateTimePicker", LazyFormsGeneratorDateTimePicker],
["FormsGeneratorDefaultChip", LazyFormsGeneratorDefaultChip],
["FormsGeneratorDefaultEditor", LazyFormsGeneratorDefaultEditor],
["FormsGeneratorDefaultSelect", LazyFormsGeneratorDefaultSelect],
["FormsGenerator", LazyFormsGenerator],
["FormsGeneratorProjects", LazyFormsGeneratorProjects],
["FormsGeneratorQuantity", LazyFormsGeneratorQuantity],
["FormsGeneratorRadio", LazyFormsGeneratorRadio],
["FormsGeneratorSubFields", LazyFormsGeneratorSubFields],
["FormsGeneratorSubFieldsVideo", LazyFormsGeneratorSubFieldsVideo],
["FormsGeneratorTelephone", LazyFormsGeneratorTelephone],
["FormsGeneratorUploader", LazyFormsGeneratorUploader],
["FormsGroupAddress", LazyFormsGroupAddress],
["FormsGroupConversationsFeedback", LazyFormsGroupConversationsFeedback],
["FormsGroupConversationsProductQuote", LazyFormsGroupConversationsProductQuote],
["FormsGroupEntryForgot", LazyFormsGroupEntryForgot],
["FormsGroupEntry", LazyFormsGroupEntry],
["FormsGroupEntryLogin", LazyFormsGroupEntryLogin],
["FormsGroupEntryRegister", LazyFormsGroupEntryRegister],
["FormsGroupHelpers", LazyFormsGroupHelpers],
["FormsGroupPayment", LazyFormsGroupPayment],
["FormsGroupRecipient", LazyFormsGroupRecipient],
["FormsGroupSearch", LazyFormsGroupSearch],
["FormsGroupUploadArtwork", LazyFormsGroupUploadArtwork],
["FormsUploadFile", LazyFormsUploadFile],
["FormsUploader", LazyFormsUploader],
["HelpersAddressHtmlFormat", LazyHelpersAddressHtmlFormat],
["HelpersAuthBlock", LazyHelpersAuthBlock],
["HelpersConversationForm", LazyHelpersConversationForm],
["HelpersConversationFormWithJquery", LazyHelpersConversationFormWithJquery],
["HelpersConversation", LazyHelpersConversation],
["HelpersConversationIndexWithJquery", LazyHelpersConversationIndexWithJquery],
["HelpersConversationTypeform", LazyHelpersConversationTypeform],
["HelpersInfoHeaderBanner", LazyHelpersInfoHeaderBanner],
["HelpersLoadingError", LazyHelpersLoadingError],
["HelpersOurClientsIcons", LazyHelpersOurClientsIcons],
["HelpersPagination", LazyHelpersPagination],
["HelpersProgressConsole", LazyHelpersProgressConsole],
["HelpersReviewsCustomers", LazyHelpersReviewsCustomers],
["HelpersReviews", LazyHelpersReviews],
["HelpersReviewsItem", LazyHelpersReviewsItem],
["HelpersSocials", LazyHelpersSocials],
["HelpersSpecificationsCollapsible", LazyHelpersSpecificationsCollapsible],
["HelpersTeam", LazyHelpersTeam],
["HelpersThankYouMessage", LazyHelpersThankYouMessage],
["HelpersTimeStripe", LazyHelpersTimeStripe],
["HelpersTooltipHelpers", LazyHelpersTooltipHelpers],
["PagesCardPayment", LazyPagesCardPayment],
["PagesCatalog", LazyPagesCatalog],
["PagesCheckoutBilling", LazyPagesCheckoutBilling],
["PagesCheckout", LazyPagesCheckout],
["PagesCheckoutListItemAddons", LazyPagesCheckoutListItemAddons],
["PagesCheckoutListItem", LazyPagesCheckoutListItem],
["PagesCheckoutListItemMainProduct", LazyPagesCheckoutListItemMainProduct],
["PagesCheckoutListItemMessages", LazyPagesCheckoutListItemMessages],
["PagesCheckoutListItemShippings", LazyPagesCheckoutListItemShippings],
["PagesCheckoutListItemShippingsItem", LazyPagesCheckoutListItemShippingsItem],
["PagesCheckoutMain", LazyPagesCheckoutMain],
["PagesCustomerAddresses", LazyPagesCustomerAddresses],
["PagesCustomerCampaignsDetails", LazyPagesCustomerCampaignsDetails],
["PagesCustomerCampaignsDetailsMain", LazyPagesCustomerCampaignsDetailsMain],
["PagesCustomerCampaignsDetailsRecipients", LazyPagesCustomerCampaignsDetailsRecipients],
["PagesCustomerCampaignsDetailsRecipientsList", LazyPagesCustomerCampaignsDetailsRecipientsList],
["PagesCustomerCampaigns", LazyPagesCustomerCampaigns],
["PagesCustomerCampaignsList", LazyPagesCustomerCampaignsList],
["PagesCustomerCampaignsMain", LazyPagesCustomerCampaignsMain],
["PagesCustomerCompanyDashboard", LazyPagesCustomerCompanyDashboard],
["PagesCustomerCompanyDashboardList", LazyPagesCustomerCompanyDashboardList],
["PagesCustomerCompanyDashboardMain", LazyPagesCustomerCompanyDashboardMain],
["PagesCustomerCompanyUserManagementCard", LazyPagesCustomerCompanyUserManagementCard],
["PagesCustomerCompanyUserManagement", LazyPagesCustomerCompanyUserManagement],
["PagesCustomerCompanyUserManagementUser", LazyPagesCustomerCompanyUserManagementUser],
["PagesCustomerDashboard", LazyPagesCustomerDashboard],
["PagesCustomerEntryForm", LazyPagesCustomerEntryForm],
["PagesCustomerGallery", LazyPagesCustomerGallery],
["PagesCustomerHeadline", LazyPagesCustomerHeadline],
["PagesCustomer", LazyPagesCustomer],
["PagesCustomerInformation", LazyPagesCustomerInformation],
["PagesCustomerIntegrationsAndApi", LazyPagesCustomerIntegrationsAndApi],
["PagesCustomerIntegrationsAndApiZapier", LazyPagesCustomerIntegrationsAndApiZapier],
["PagesCustomerNotifications", LazyPagesCustomerNotifications],
["PagesCustomerOrdersDetails", LazyPagesCustomerOrdersDetails],
["PagesCustomerOrdersExternal", LazyPagesCustomerOrdersExternal],
["PagesCustomerOrdersExternalMain", LazyPagesCustomerOrdersExternalMain],
["PagesCustomerOrders", LazyPagesCustomerOrders],
["PagesCustomerOrdersMain", LazyPagesCustomerOrdersMain],
["PagesCustomerOrdersShortDetails", LazyPagesCustomerOrdersShortDetails],
["PagesCustomerPassword", LazyPagesCustomerPassword],
["PagesCustomerPaymentsCard", LazyPagesCustomerPaymentsCard],
["PagesCustomerPayments", LazyPagesCustomerPayments],
["PagesCustomerPaymentsTransactions", LazyPagesCustomerPaymentsTransactions],
["PagesCustomerProjectsApprovalsDetails", LazyPagesCustomerProjectsApprovalsDetails],
["PagesCustomerProjectsApprovals", LazyPagesCustomerProjectsApprovals],
["PagesCustomerProjectsApprovalsList", LazyPagesCustomerProjectsApprovalsList],
["PagesCustomerProjectsApprovalsMain", LazyPagesCustomerProjectsApprovalsMain],
["PagesCustomerProjects", LazyPagesCustomerProjects],
["PagesCustomerProjectsProjectCard", LazyPagesCustomerProjectsProjectCard],
["PagesCustomerProjectsSalesRepForm", LazyPagesCustomerProjectsSalesRepForm],
["PagesCustomerRedeemDetails", LazyPagesCustomerRedeemDetails],
["PagesCustomerRedeemDetailsMain", LazyPagesCustomerRedeemDetailsMain],
["PagesCustomerRedeemDetailsRecipients", LazyPagesCustomerRedeemDetailsRecipients],
["PagesCustomerRedeemDetailsRecipientsList", LazyPagesCustomerRedeemDetailsRecipientsList],
["PagesCustomerRedeem", LazyPagesCustomerRedeem],
["PagesCustomerRedeemList", LazyPagesCustomerRedeemList],
["PagesCustomerRedeemMain", LazyPagesCustomerRedeemMain],
["PagesCustomerReferrals", LazyPagesCustomerReferrals],
["PagesCustomerSidebar", LazyPagesCustomerSidebar],
["PagesCustomerSidebarShowBtn", LazyPagesCustomerSidebarShowBtn],
["PagesCustomerThankYouNotesCard", LazyPagesCustomerThankYouNotesCard],
["PagesCustomerThankYouNotes", LazyPagesCustomerThankYouNotes],
["PagesDesignerAddons", LazyPagesDesignerAddons],
["PagesDesignerCustomizerActions", LazyPagesDesignerCustomizerActions],
["PagesDesignerCustomizerEditor", LazyPagesDesignerCustomizerEditor],
["PagesDesignerCustomizerHelp", LazyPagesDesignerCustomizerHelp],
["PagesDesignerCustomizer", LazyPagesDesignerCustomizer],
["PagesDesignerCustomizerOptionsAttrs", LazyPagesDesignerCustomizerOptionsAttrs],
["PagesDesignerCustomizerOptions", LazyPagesDesignerCustomizerOptions],
["PagesDesignerCustomizerOptionsText", LazyPagesDesignerCustomizerOptionsText],
["PagesDesignerCustomizerOptionsUploader", LazyPagesDesignerCustomizerOptionsUploader],
["PagesDesignerCustomizerPromts", LazyPagesDesignerCustomizerPromts],
["PagesDesignerCustomizerSideSwitch", LazyPagesDesignerCustomizerSideSwitch],
["PagesDesignerCustomizerType", LazyPagesDesignerCustomizerType],
["PagesDesignerDiscountModal", LazyPagesDesignerDiscountModal],
["PagesDesignerHeader", LazyPagesDesignerHeader],
["PagesDesigner", LazyPagesDesigner],
["PagesDesignerQuoteSidebar", LazyPagesDesignerQuoteSidebar],
["PagesDesignerReceipt", LazyPagesDesignerReceipt],
["PagesDesignerReceiptProducts", LazyPagesDesignerReceiptProducts],
["PagesDesignerSpecifications", LazyPagesDesignerSpecifications],
["PagesDesignerYourinfo", LazyPagesDesignerYourinfo],
["PagesFaq", LazyPagesFaq],
["PagesNotFound", LazyPagesNotFound],
["PagesOrderSuccess", LazyPagesOrderSuccess],
["PagesPage", LazyPagesPage],
["PagesPreviewMode", LazyPagesPreviewMode],
["PagesProductActionsForm", LazyPagesProductActionsForm],
["PagesProduct", LazyPagesProduct],
["PagesSearch", LazyPagesSearch],
["PagesSharedClaimGiftCheckEmail", LazyPagesSharedClaimGiftCheckEmail],
["PagesSharedClaimGiftEmailPreview", LazyPagesSharedClaimGiftEmailPreview],
["PagesSharedClaimGift", LazyPagesSharedClaimGift],
["PagesSharedClaimGiftInfoClaimed", LazyPagesSharedClaimGiftInfoClaimed],
["PagesSharedClaimGiftInfoForm", LazyPagesSharedClaimGiftInfoForm],
["PagesSharedClaimGiftInfoGiftCard", LazyPagesSharedClaimGiftInfoGiftCard],
["PagesSharedClaimGiftInfoGifts", LazyPagesSharedClaimGiftInfoGifts],
["PagesSharedClaimGiftInfo", LazyPagesSharedClaimGiftInfo],
["PagesSharedClaimGiftInfoMain", LazyPagesSharedClaimGiftInfoMain],
["PagesSharedClaimGiftInfoMessage", LazyPagesSharedClaimGiftInfoMessage],
["PagesSharedClaimGiftInfoThankYou", LazyPagesSharedClaimGiftInfoThankYou],
["PagesShared", LazyPagesShared],
["PagesSharedProject", LazyPagesSharedProject],
["PagesSharedThankYou", LazyPagesSharedThankYou],
["PagesSharedUploader", LazyPagesSharedUploader],
["PagesSharedVideoLibrary", LazyPagesSharedVideoLibrary],
["PagesSharedVideoMessage", LazyPagesSharedVideoMessage],
["PagesSitemap", LazyPagesSitemap],
["PagesThankYou", LazyPagesThankYou],
["PagesUnsubscribe", LazyPagesUnsubscribe],
["PopupsCookiesAgree", LazyPopupsCookiesAgree],
["PopupsCustomDrawer", LazyPopupsCustomDrawer],
["PopupsPrivacyPolicy", LazyPopupsPrivacyPolicy],
["PopupsSubscribe", LazyPopupsSubscribe],
["PopupsToastExpired", LazyPopupsToastExpired],
["PopupsUnsupportedBrowser", LazyPopupsUnsupportedBrowser],
["PopupsVideoPreviewOverlay", LazyPopupsVideoPreviewOverlay],
["ServiceCodes", LazyServiceCodes],
["VercelCodes", LazyVercelCodes],
["WidgetsBannersSimpleVideo", LazyWidgetsBannersSimpleVideo],
["WidgetsHeadlineSimple", LazyWidgetsHeadlineSimple],
["Widgets", LazyWidgets],
["WidgetsPagesAboutUs", LazyWidgetsPagesAboutUs],
["WidgetsPagesAdvantages", LazyWidgetsPagesAdvantages],
["WidgetsPagesAdvantagesProduct", LazyWidgetsPagesAdvantagesProduct],
["WidgetsPagesAnnouncementBanner", LazyWidgetsPagesAnnouncementBanner],
["WidgetsPagesAnnouncementBannerSecond", LazyWidgetsPagesAnnouncementBannerSecond],
["WidgetsPagesBannerAndContentWithReverse", LazyWidgetsPagesBannerAndContentWithReverse],
["WidgetsPagesBannerDescrWithItems", LazyWidgetsPagesBannerDescrWithItems],
["WidgetsPagesBannerDescrWithTabsItems", LazyWidgetsPagesBannerDescrWithTabsItems],
["WidgetsPagesBannerTitleDescrButton", LazyWidgetsPagesBannerTitleDescrButton],
["WidgetsPagesCardBlocks", LazyWidgetsPagesCardBlocks],
["WidgetsPagesContentBlocksWithButton", LazyWidgetsPagesContentBlocksWithButton],
["WidgetsPagesDivided", LazyWidgetsPagesDivided],
["WidgetsPagesFeedback", LazyWidgetsPagesFeedback],
["WidgetsPagesGallery", LazyWidgetsPagesGallery],
["WidgetsPagesGalleryBlocks", LazyWidgetsPagesGalleryBlocks],
["WidgetsPagesGalleryBlocksModalInfo", LazyWidgetsPagesGalleryBlocksModalInfo],
["WidgetsPagesHtmlContent", LazyWidgetsPagesHtmlContent],
["WidgetsPagesHtmlContentItems", LazyWidgetsPagesHtmlContentItems],
["WidgetsPagesItemsBannerTitleBlock", LazyWidgetsPagesItemsBannerTitleBlock],
["WidgetsPagesItemsTitleDescr", LazyWidgetsPagesItemsTitleDescr],
["WidgetsPagesItemsTitleDescrIcon", LazyWidgetsPagesItemsTitleDescrIcon],
["WidgetsPagesItemsTitleDescrIconBlocks", LazyWidgetsPagesItemsTitleDescrIconBlocks],
["WidgetsPagesLocalStorage", LazyWidgetsPagesLocalStorage],
["WidgetsPagesNavigationContent", LazyWidgetsPagesNavigationContent],
["WidgetsPagesOurClients", LazyWidgetsPagesOurClients],
["WidgetsPagesOurDifference", LazyWidgetsPagesOurDifference],
["WidgetsPagesBannerDescrWithCollapsibleItems", LazyWidgetsPagesBannerDescrWithCollapsibleItems],
["WidgetsPagesProducts", LazyWidgetsPagesProducts],
["WidgetsPagesQuestions", LazyWidgetsPagesQuestions],
["WidgetsPagesRetailersIcons", LazyWidgetsPagesRetailersIcons],
["WidgetsPagesReviewsAndClients", LazyWidgetsPagesReviewsAndClients],
["WidgetsPagesReviewsExternal", LazyWidgetsPagesReviewsExternal],
["WidgetsPagesSliderAndContentWithReverse", LazyWidgetsPagesSliderAndContentWithReverse],
["WidgetsPagesSliderBlocks", LazyWidgetsPagesSliderBlocks],
["WidgetsPagesSliderReviews", LazyWidgetsPagesSliderReviews],
["WidgetsPagesSliderSteps", LazyWidgetsPagesSliderSteps],
["WidgetsPagesStepper", LazyWidgetsPagesStepper],
["WidgetsSystemBreadcrumbs", LazyWidgetsSystemBreadcrumbs],
["WidgetsSystemProductsCard", LazyWidgetsSystemProductsCard],
["WidgetsSystemProductsCardPlaceholder", LazyWidgetsSystemProductsCardPlaceholder],
["WidgetsSystemProductsFilters", LazyWidgetsSystemProductsFilters],
["WidgetsSystemProducts", LazyWidgetsSystemProducts],
["WidgetsSystemProductsLoadMore", LazyWidgetsSystemProductsLoadMore],
["AutoComplete", LazyAutoComplete],
["Calendar", LazyCalendar],
["CascadeSelect", LazyCascadeSelect],
["Checkbox", LazyCheckbox],
["CheckboxGroup", LazyCheckboxGroup],
["Chips", LazyChips],
["ColorPicker", LazyColorPicker],
["DatePicker", LazyDatePicker],
["Dropdown", LazyDropdown],
["Editor", LazyEditor],
["FloatLabel", LazyFloatLabel],
["Fluid", LazyFluid],
["IconField", LazyIconField],
["IftaLabel", LazyIftaLabel],
["InputChips", LazyInputChips],
["InputGroup", LazyInputGroup],
["InputGroupAddon", LazyInputGroupAddon],
["InputIcon", LazyInputIcon],
["InputMask", LazyInputMask],
["InputNumber", LazyInputNumber],
["InputOtp", LazyInputOtp],
["InputSwitch", LazyInputSwitch],
["InputText", LazyInputText],
["Knob", LazyKnob],
["Listbox", LazyListbox],
["MultiSelect", LazyMultiSelect],
["Password", LazyPassword],
["RadioButton", LazyRadioButton],
["RadioButtonGroup", LazyRadioButtonGroup],
["Rating", LazyRating],
["Select", LazySelect],
["SelectButton", LazySelectButton],
["Slider", LazySlider],
["Textarea", LazyTextarea],
["ToggleButton", LazyToggleButton],
["ToggleSwitch", LazyToggleSwitch],
["TreeSelect", LazyTreeSelect],
["Button", LazyButton],
["ButtonGroup", LazyButtonGroup],
["SpeedDial", LazySpeedDial],
["SplitButton", LazySplitButton],
["Column", LazyColumn],
["Row", LazyRow],
["ColumnGroup", LazyColumnGroup],
["DataTable", LazyDataTable],
["DataView", LazyDataView],
["OrderList", LazyOrderList],
["OrganizationChart", LazyOrganizationChart],
["Paginator", LazyPaginator],
["PickList", LazyPickList],
["Tree", LazyTree],
["TreeTable", LazyTreeTable],
["Timeline", LazyTimeline],
["VirtualScroller", LazyVirtualScroller],
["Accordion", LazyAccordion],
["AccordionPanel", LazyAccordionPanel],
["AccordionHeader", LazyAccordionHeader],
["AccordionContent", LazyAccordionContent],
["AccordionTab", LazyAccordionTab],
["Card", LazyCard],
["DeferredContent", LazyDeferredContent],
["Divider", LazyDivider],
["Fieldset", LazyFieldset],
["Panel", LazyPanel],
["ScrollPanel", LazyScrollPanel],
["Splitter", LazySplitter],
["SplitterPanel", LazySplitterPanel],
["Stepper", LazyStepper],
["StepList", LazyStepList],
["Step", LazyStep],
["StepItem", LazyStepItem],
["StepPanels", LazyStepPanels],
["StepPanel", LazyStepPanel],
["TabView", LazyTabView],
["Tabs", LazyTabs],
["TabList", LazyTabList],
["Tab", LazyTab],
["TabPanels", LazyTabPanels],
["TabPanel", LazyTabPanel],
["Toolbar", LazyToolbar],
["ConfirmDialog", LazyConfirmDialog],
["ConfirmPopup", LazyConfirmPopup],
["Dialog", LazyDialog],
["Drawer", LazyDrawer],
["DynamicDialog", LazyDynamicDialog],
["OverlayPanel", LazyOverlayPanel],
["Popover", LazyPopover],
["Sidebar", LazySidebar],
["FileUpload", LazyFileUpload],
["Breadcrumb", LazyBreadcrumb],
["ContextMenu", LazyContextMenu],
["Dock", LazyDock],
["Menu", LazyMenu],
["Menubar", LazyMenubar],
["MegaMenu", LazyMegaMenu],
["PanelMenu", LazyPanelMenu],
["Steps", LazySteps],
["TabMenu", LazyTabMenu],
["TieredMenu", LazyTieredMenu],
["Chart", LazyChart],
["Message", LazyMessage],
["InlineMessage", LazyInlineMessage],
["Toast", LazyToast],
["Carousel", LazyCarousel],
["Galleria", LazyGalleria],
["Image", LazyImage],
["ImageCompare", LazyImageCompare],
["Avatar", LazyAvatar],
["AvatarGroup", LazyAvatarGroup],
["Badge", LazyBadge],
["BlockUI", LazyBlockUI],
["Chip", LazyChip],
["Inplace", LazyInplace],
["MeterGroup", LazyMeterGroup],
["OverlayBadge", LazyOverlayBadge],
["ScrollTop", LazyScrollTop],
["Skeleton", LazySkeleton],
["ProgressBar", LazyProgressBar],
["ProgressSpinner", LazyProgressSpinner],
["Tag", LazyTag],
["Terminal", LazyTerminal],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
